import { detailUserInfo } from "./api"
export default {
    data() {
        return {
            // 是否登录
            isLogin: false,
            // 个人信息
            userInfoData: null,
        }
    },
    created() {
        // 处理token
        let token = window.$CCDK.CCToken.getToken("communityToken", "communityToken");
        if (token) {
            // 获取用户信息
            detailUserInfo().then((res) => {
                if (res.result) {
                    // 设置用户信息
                    window.$CCDK.CCUser.setUserInfo(
                        res.data,
                        undefined,
                        "communityUserInfo"
                    );
                    // 用户信息
                    this.userInfoData = res.data;
                    // 已登录
                    this.isLogin = true;
                } else {
                    Message.warning(res.customInfo);
                }
            });
        } else {
            // 未登录
            this.isLogin = false;
        }
    }
}